<button
  id="close-modal-button"
  type="button"
  class="close close-modal-top"
  aria-label="Close"
  (click)="activeModal.dismiss('Cross click')"
>
  <span aria-hidden="true" style="float: right; margin-right: -14px"
    >&times;</span
  >
</button>
<div id="order-documents-modal" style="border-style: initial">
  <div id="order-documents-frame" class="border order-documents-frame">
    <div class="header">
      <h2 class="modal-title-info">
        {{ 'ORDER-DOCUMENTS.TITLE' | translate }} {{ orderId }}
      </h2>
    </div>
    <div
      class="extra-documents-container container-blue-open"
      style="padding-top: 20px"
    >
      <div class="row" style="display: grid" id="add-document-div">
        <p class="error-text">
          <span *ngIf="atLeastOneDocumentIsMandatory; else noMessage">
            {{ 'ORDER-DOCUMENTS.HAS-MANDATORY-DOCS-TEXT' | translate }}
          </span>
          <ng-template #noMessage><p></p></ng-template>
        </p>
        <button
          type="button"
          class="close close-modal-top"
          id="add-document-button"
          title="Add other document"
          [disabled]="isImpersonated"
          (click)="addOtherDocument()"
        >
          <em
            class="icon-grey title-action-btn fa fa-plus"
            aria-hidden="true"
          ></em>
        </button>
        <app-file-input
          name="addOrderDocument"
          [validExtensions]="validExtensions"
          [maxSizeMb]="10"
          (getFile)="upload($event)"
        ></app-file-input>
      </div>
      <mat-table
        id="order-documents-table"
        [ngClass]="shouldScrollBeDisplayed() ? 'withScrollY' : 'noScroll'"
        class="table-blue-container table table-striped mat-table-modal-multi carrier-overview-table mat-table-modal"
        [dataSource]="documentDatasource"
        matSort
        class="hide-mobile hide-tablet-portrait"
      >
        <div class="row">
          <ng-container matColumnDef="status">
            <mat-header-cell
              *matHeaderCellDef
              mat-header-cell
              class="mat-table-header medium-size-column"
            >
              {{ 'ORDER-DOCUMENTS.STATUS-HEADER' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="medium-size-column">
              <em
                *ngIf="element.status === docStatus.Valid"
                style="color: green"
                class="fas fa-lg fa-check"
              ></em>
              <em
                *ngIf="element.status === docStatus.Missing"
                style="color: orange"
                class="fas fa-lg fa-exclamation-triangle"
              ></em>
              <em *ngIf="element.status === docStatus.NotRequired"></em>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="documentType">
            <mat-header-cell
              *matHeaderCellDef
              mat-header-cell
              class="mat-table-header extra-large-size-column"
            >
              {{ 'ORDER-DOCUMENTS.DOCUMENT-TYPE-HEADER' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="extra-large-size-column">
              {{ element.type }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="uploadedDocument">
            <mat-header-cell
              *matHeaderCellDef
              mat-header-cell
              class="mat-table-header extra-large-size-column"
            >
              {{ 'ORDER-DOCUMENTS.UPLOADED-DOCUMENT-HEADER' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="extra-large-size-column">
              {{ element.fileName }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions">
            <mat-header-cell
              *matHeaderCellDef
              mat-header-cell
              class="mat-table-header extra-large-size-column"
            >
              {{ 'ORDER-DOCUMENTS.ACTIONS-HEADER' | translate }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              class="extra-large-size-column actions-cell"
            >
              <div class="buttons">
                <button
                  (click)="browse(element)"
                  class="btn btn-lg btn-outline-primary doc-icon"
                  [disabled]="isImpersonated"
                >
                  <em class="fas fa-cloud-upload-alt"></em>
                </button>
                <button
                  (click)="view(element.id, element.fileName)"
                  *ngIf="element.status === docStatus.Valid"
                  class="btn btn-lg btn-outline-info doc-icon"
                >
                  <em class="fas fa-eye"></em>
                </button>
              </div>
            </mat-cell>
          </ng-container>
        </div>
        <mat-header-row
          class="header-column"
          *matHeaderRowDef="columnsToDisplay"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: columnsToDisplay"> </mat-row>
      </mat-table>

      <mat-accordion
        multi
        class="hide-desktop hide-tablet-landscape"
        id="order-documents-accordion"
      >
        <mat-expansion-panel
          #docPanel
          *ngFor="let element of this.documentDatasource.data"
          class="docs-card-text"
          (opened)="openDocPanel(docPanel)"
        >
          <mat-expansion-panel-header
            (click)="
              isExpandablePanel(element)
                ? $event.stopPropagation()
                : docPanel.toggle()
            "
            [class.hidden-expansion-arrow]="!isExpandablePanel(element)"
          >
            <em
              *ngIf="element.status === docStatus.Valid"
              style="color: green"
              class="fas fa-check doc-status-icon"
            ></em>
            <em
              *ngIf="element.status === docStatus.Missing"
              style="color: orange"
              class="fas fa-exclamation-triangle doc-status-icon"
            ></em>
            <em
              *ngIf="element.status === docStatus.NotRequired"
              id="not-required-doc-icon"
            ></em>
            &nbsp;

            <div class="docs-card-text col-8 doc-type">
              {{ element.type }}
            </div>

            <div class="buttons" id="doc-buttons">
              <button
                (click)="browse(element)"
                class="btn btn-lg btn-outline-primary doc-icon"
              >
                <em class="fas fa-lg fa-cloud-upload-alt"></em>
              </button>
            </div>
          </mat-expansion-panel-header>
          <div
            class="link"
            id="doc-file-name"
            (click)="view(element.id, element.fileName)"
          >
            <b>{{ this.formatName(element.fileName) }}</b>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div *ngIf="uploadInProgress">
      <app-loading-indicator
        [loadingMessage]="'ORDER-DOCUMENTS.UPLOAD-IN-PROGRESS' | translate"
      ></app-loading-indicator>
    </div>
    <p
      *ngIf="uploadFeedbackMessage"
      class="error-text upload-feedback-message"
      id="upload-feedback-message"
    >
      {{ uploadFeedbackMessage | translate }}
    </p>
  </div>
</div>
